export const isDevelop =
  window.location.hostname.includes('test') ||
  window.location.hostname.includes('192.168') ||
  window.location.hostname.includes('localhost')

export const AUTH_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-auth'
  : 'https://asterx.kz/api-auth'

export const CP_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-cp'
  : 'https://asterx.kz/api-cp'

export const BLUR_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-market-integration'
  : 'https://asterx.kz/api-market-integration'

export const CAR_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-car'
  : 'https://asterx.kz/api-car'

export const REPORT_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-report'
  : 'https://asterx.kz/api-report'

export const DICT_API = isDevelop
  ? 'https://test.asterx.kz/api-dict'
  : 'https://asterx.kz/api-dict'

export const ASTER_MARKET = isDevelop
  ? 'https://test-market-dev3.asterx.kz'
  : 'https://aster.kz'

export const NOTIFICATION_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-notification'
  : 'https://asterx.kz/api-notification'

export const TIRES_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-tires'
  : 'https://asterx.kz/api-tires'

export const CS_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-sale'
  : 'https://asterx.kz/api-sale'

export const PPP_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-ppp'
  : 'https://asterx.kz/api-ppp'

export const SEO_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-seo'
  : 'https://asterx.kz/api-seo'

export const KEY_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-key'
  : 'https://asterx.kz/api-key'

export const FB_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-fb'
  : 'https://asterx.kz/api-fb'

export const BEE_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-bee'
  : 'https://asterx.kz/api-bee'

export const CONTRACTS_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-cs-contracts'
  : 'https://asterx.kz/api-cs-contracts'

export const CLIENT_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-client'
  : 'https://asterx.kz/api-client'

export const MISC_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-misc'
  : 'https://asterx.kz/api-misc'

export const INTEGRATION_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-sale/integration'
  : 'https://asterx.kz/api-sale/integration'

export const CS_NEW_API_URL = isDevelop
  ? 'https://test.asterx.kz/api-sale-new-auto'
  : 'https://asterx.kz/api-sale-new-auto'

export const BONUS_API = isDevelop
  ? 'https://test.asterx.kz/api-bonus'
  : 'https://asterx.kz/api-bonus'



export const BONUS_API_ADMIN = isDevelop
? 'https://test.asterx.kz/api-bonus/admin'
: 'https://asterx.kz/api-bonus/admin'
